import React, { useEffect } from "react";
import { Redirect, withRouter } from "react-router-dom";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { useDispatch } from "react-redux";
import { logOut } from "../../../../redux/user/userActions";

const Logout = ({ history }) => {
  const dispatch = useDispatch();

  const token = localStorage.getItem("token");

  useEffect(() => {
    dispatch(logOut());
    history.push("/auth/login");
  }, [dispatch, history]);
  return token ? <LayoutSplashScreen /> : <Redirect to="/dashboard" />;
};

export default withRouter(Logout);
